import { $form, $view } from 'signals/global.signals';
import { updateUser } from 'api/users.api';
import displayError from 'utils/displayError';
import { handleHideModal, handleShowModal } from 'components/global/_helpers/global.helpers';
import displayNotification from 'utils/displayNotification';
import { deleteInvite, resendInvite, sendInvite } from 'api/invites.api';
import { fetchAndSetFounderInvites, fetchAndSetOrganizationUsers } from './founderTeam.resolvers';

export const handleSubmitEditPerson = async () => {
  try {
    $view.update({
      isModalLoading: true,
    });

    const userData = {
      firstName: $form.value.firstName,
      lastName: $form.value.lastName,
      email: $form.value.email,
      roles: $form.value.roles,
    };

    await updateUser($form.value.id, userData);
    displayNotification({ message: 'User updated successfully', title: 'User updated' });
  } catch (error) {
    displayError({
      message: 'Failed to update user. Please check your information and try again.',
      title: 'User Update Error',
    });
  } finally {
    $view.update({
      isModalLoading: false,
    });
    handleHideModal();
    await fetchAndSetOrganizationUsers();
  }
};

export const handleSubmitDeletePerson = async () => {
  try {
    $view.update({
      isModalLoading: true,
    });
    await updateUser($form.value.id, { archived: true });
    displayNotification({ message: 'User archived successfully', title: 'User archived' });
  } catch (error) {
    displayError({
      message: 'Failed to archive user. Please try again.',
      title: 'User Archive Error',
    });
  } finally {
    $view.update({
      isModalLoading: false,
    });
    handleHideModal();
    await fetchAndSetOrganizationUsers();
  }
};

export const handleClickResendInvite = async (id) => {
  try {
    await resendInvite(id);
    displayNotification({
      message: 'Invite resent successfully',
      title: 'Invite resent',
    });
  } catch (error) {
    displayError({
      message: 'Failed to resend invitation. Please try again.',
      title: 'Resend Invitation Error',
    });
  } finally {
    await fetchAndSetFounderInvites();
  }
};

export const handleClickDeleteInvite = async (id) => {
  try {
    await deleteInvite(id);
    displayNotification({ message: 'Invite deleted successfully', title: 'Invite deleted' });
  } catch (error) {
    displayError({
      message: 'Failed to delete invitation. Please try again.',
      title: 'Delete Invitation Error',
    });
  } finally {
    await fetchAndSetFounderInvites();
  }
};

export const handleSubmitSendInvite = async () => {
  try {
    $view.update({
      isModalLoading: true,
    });

    await sendInvite({
      email: $form.value.email,
      userTypeId: 1, // Hardcoded to investor
    });
    displayNotification({ message: 'Invite sent successfully', title: 'Invite sent' });
  } catch (error) {
    displayError({
      message: 'Failed to send invitation. Please check the email address and try again.',
      title: 'Send Invitation Error',
    });
  } finally {
    $view.update({
      isModalLoading: false,
    });
    handleHideModal();
    $view.update({
      activeTab: 'Pending Invites',
    });
    await fetchAndSetFounderInvites();
  }
};

export const handleClickEditPerson = (person) => {
  handleShowModal('edit-person', {
    id: person.id,
    firstName: person.firstName,
    lastName: person.lastName,
    email: person.email,
    roles: person.roles,
  });
};

export const handleClickEditTeam = (team) => {
  handleShowModal('edit-team', {
    id: team.id,
    name: team.name,
    users: team.users.map((user) => ({ label: `${user.firstName} ${user.lastName}`, value: user.id })),
  });
};
